// import { AppConstants } from "@/app.constants";

import { AppConstants } from "@/app.constants";

export const generateUniqueId = (): string => {
    return crypto.randomUUID();
};

/**
 * Interpolates a string by replacing placeholders like {0}, {1}, etc. with provided values
 * @param template - The string template with placeholders (e.g., "Hello {0}, welcome to {1}")
 * @param values - Array of values to replace the placeholders
 * @returns The interpolated string
 * 
 * @example
 * interpolate("Hello {0}, welcome to {1}", ["John", "our app"])
 * // Returns: "Hello John, welcome to our app"
 */
export const interpolate = (template: string, values: any[]): string => {
    if (!template || !values || values.length === 0) {
        return template;
    }
    
    return template.replace(/\{(\d+)\}/g, (match, index) => {
        const valueIndex = parseInt(index, 10);
        return values[valueIndex] !== undefined ? String(values[valueIndex]) : match;
    });
};

// export const decodeBase64ImageUrl = (url: string) => {
//     return url?.replaceAll(AppConstants.IMAGE_URL_SEPARATOR, ',');
// }
// export const encodeBase64ImageUrl = (url: string) => {
//     return url?.replaceAll(',', AppConstants.IMAGE_URL_SEPARATOR);
// }

export function getFileExtension(file: File): string | null {
    const fileName = file.name;
    const extensionMatch = fileName.match(/\.[0-9a-z]+$/i); // Regex to match the file extension
    return extensionMatch ? extensionMatch[0] : null; // Return extension including the dot or null if not found
}
export const removeImageUrl = (imgUrls: string, url: string): string => {
    if (!imgUrls) return "";

    const urls = imgUrls
        .split(AppConstants.IMAGE_URL_SEPARATOR)
        .map(u => u.trim()) // Optional: Normalize spacing
        .filter(u => u !== url); // Remove the matching URL

    return urls.join(AppConstants.IMAGE_URL_SEPARATOR);
};

export const toNumber = (input: string) => Number(input?.replace(',', '.'));
